import React from 'react';
import { Container } from './Error.style';
import { ErrorGeneratedProps } from './Error.props';

const ErrorView = (props: ErrorGeneratedProps): JSX.Element => (
  <Container>Error</Container>
);

export default ErrorView;
